import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';

// Initialize state from localStorage
const loadStateFromStorage = () => {
  try {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    
    if (token && userStr) {
      const user = JSON.parse(userStr);
      return {
        auth: {
          user,
          token,
          isAuthenticated: true,
          isLoading: false,
        },
      };
    }
  } catch (e) {
    console.error('Error loading state from storage:', e);
  }
  
  return undefined;
};

const preloadedState = loadStateFromStorage();

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  preloadedState,
});

export default store;
